var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInbound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14.9999V16.1999C21 17.88 21 18.7201 20.673 19.3619C20.3854 19.9263 19.9265 20.3853 19.362 20.6729C18.7202 20.9999 17.8802 20.9999 16.2 20.9999H7.8C6.11984 20.9999 5.27976 20.9999 4.63803 20.6729C4.07354 20.3853 3.6146 19.9263 3.32698 19.3619C3 18.7201 3 17.88 3 16.1999V14.9999M17 9.99988L12 14.9999M12 14.9999L7 9.99988M12 14.9999V2.99988",
    stroke: "url(#paint0_linear_3432_1077)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3432_1077",
    x1: 12,
    y1: 2.99988,
    x2: 12,
    y2: 20.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33C2B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F5CE6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbound);
export default __webpack_public_path__ + "static/media/Inbound.7d38eb6460ca4b7ee8ccc3f59776adc4.svg";
export { ForwardRef as ReactComponent };